import { render, staticRenderFns } from "./leapoAI.vue?vue&type=template&id=5f3f6b1e&scoped=true"
import script from "./leapoAI.vue?vue&type=script&lang=js"
export * from "./leapoAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f6b1e",
  null
  
)

export default component.exports